import { Spinner } from 'app/components/ui/spinner';

interface LoadingScreenProps {
  'data-testid'?: string;
}

/**
 * The single full-screen loading state for the whole app. Every boot gate
 * (theme/building, the lazy route Suspense fallback, the auth `Private` guard,
 * and each page's own data load) renders this same centered spinner, so the
 * loader stays in one place across the whole boot sequence instead of jumping
 * between the differently-positioned wrappers we used before.
 */
export const LoadingScreen = ({ 'data-testid': testId = 'loading-screen' }: LoadingScreenProps): JSX.Element => (
  <div data-testid={testId} className="flex h-screen w-full flex-col items-center justify-center">
    <Spinner />
  </div>
);
